function getParams(e) {
  var r = {},
    t = document.createElement("a");
  t.href = e;
  for (var n = t.search.substring(1).split("&"), a = 0; a < n.length; a++) {
    var o = n[a].split("=");
    r[o[0]] = decodeURIComponent(o[1])
  }
  return r
};


function scrollDirection(){
  this.pos = 0
  this.direction = false
  var _this = this
  window.addEventListener('scroll', function(){
    if ((document.body.getBoundingClientRect()).top > _this.pos){
      _this.direction = 'up'
    }else{
      _this.direction = 'down'
    }
	_this.pos = (document.body.getBoundingClientRect()).top;
  });
}


